import { getFacebookMatchParameters, isCapiPageViewHost } from './facebookConversionsApi'
import { getGoogleMatchParameters, getMicrosoftMatchParameters } from './adClickIdentifiers'

// Match parameters for the Segment CAPI destinations; the *_match_params_present
// flags are what the destination triggers filter on.
export const buildCapiMatchProperties = () => {
  const properties = {}

  const facebook = getFacebookMatchParameters()
  Object.assign(properties, facebook)
  properties.fb_match_params_present = Object.keys(facebook).length > 0

  const microsoft = getMicrosoftMatchParameters()
  Object.assign(properties, microsoft)
  properties.microsoft_match_params_present = Object.keys(microsoft).length > 0

  const google = getGoogleMatchParameters()
  Object.assign(properties, google)
  properties.google_match_params_present = Object.keys(google).length > 0

  return properties
}

// Ad-platform conversion actions map to track events (click, quiz_*), which need
// the same match parameters as page. page() stays enriched at call time in
// layout.js so it doesn't depend on snippet queue flush order.
export const capiTrackSourceMiddleware = ({ payload, next }) => {
  try {
    if (payload?.obj?.type === 'track' && isCapiPageViewHost()) {
      payload.obj.properties = {
        ...buildCapiMatchProperties(),
        // Event-provided keys win over enrichment.
        ...payload.obj.properties,
      }
    }
  } catch (e) {
    // Enrichment must never block event delivery.
    console.error('CAPI track enrichment failed', e)
  }
  next(payload)
}
